<template>
  <div id="top">
    <div class="all pcShow">
        <div class="text-pc">
          <img src="../../assets/product-pc/pexels-chokniti-khongchum.png" alt="">
          <div class="right">
            <div class="p1">Dietary Suggestion</div>
            <div class="outer-box">
              <div class="suggest">
                <div  v-for="item in suggests" :key="item.title">
                  <div class="p2" v-html="item.title"></div>
                  <div class="p3" v-html="item.article"></div>
                </div>
              </div>
            </div>
            <!-- <div class="right-btn">
              <button>next</button>
              <div class="download">Download<a-icon type="cloud-download" /></div>
            </div> -->
            <download></download>
          </div>
        </div>
    </div>
    <div class="all mShow">
        <!-- <Header></Header> -->
        <div class="text">
          <div class="p1">Dietary Suggestion</div>
          <div class="outer">
            <div class="suggest">
              <div  v-for="item in suggests" :key="item.title">
                <div class="p2" v-html="item.title"></div>
                <div class="p3" v-html="item.article"></div>
              </div>
            </div>
          </div>
        </div>
        <download></download>
    </div>
  </div>
</template>

<script>
import dietary from '../../mixins/dietarySugeests'
import Download from '../../components/Dowload.vue'
export default {
  components: {
    Download
  },
  mixins: [dietary],
  data () {
    return {
      suggests: []
    }
  },
  mounted () {
     // 长建议 加*做标记
    this.suggests.forEach( ( item, index ) => {
      if ( item && item.title.substr(0, 1) === '*' ) {
        this.suggests[index].title = this.suggests[index].title.substr(1)
      }
    })
    // 问卷结果页曝光 埋点
    this.$sensors.track('QuestionnaireResultExpo', {
      source: 'DietRecommend',
      hasProduct: this.$store.state.product.length > 0
    })
  }
}
</script>

<style lang="less" scoped>
#top {
  height: 100%;
  overflow: hidden;
  // background: #000000;
}
@media only screen and (max-width: 767px) {
  .all {
    width: 100%;
    overflow: hidden;
    height: 100%;
    // height: 800px;
    margin-top: 72.5px;
    display: flex;
    flex-direction: column;
    align-items: center;
  .text {
    padding: 26px 35px 265px 30px;
    height: 100%;
    // bottom: 180px;
    // top: 72.5px;
    // position: absolute;
    
    .outer {
      width: 303px;
      overflow: hidden;
      height: 100%;
    }
    .suggest {
      width: 310px;
      // height: 431px;
      overflow-y: auto;
      height: 100%;
    }
    .p1 {
      // width: 264px;
      height: 32px;
      font-size: 20px;
      font-family: Helvetica-Bold, Helvetica;
      font-weight: bold;
      color: #000000;
      line-height: 24px;
    }
    .p2 {
      // width: 162px;
      // height: 38px;
      padding-top: 8px;
      font-size: 15px;
      font-family: Helvetica;
      color: #000000;
      line-height: 18px;
    }
    .p3 {
      // width: 310px;
      // height: 105px;
      padding-top: 8px;
      padding-bottom: 22px;
      font-size: 15px;
      font-family: Helvetica-Light, Helvetica;
      font-weight: 150;
      color: #000000;
      line-height: 21px;
    }
  }
  // button {
  //   border: none;
  //   // position: relative;
  //   // margin-top: 15px;
  //   padding-top: 108;
  //   width: 225px;
  //   height: 45px;
  //   background: #E26CA5;
  //   border-radius: 36px;
  //   font-size: 17px;
  //   font-family: Helvetica-Bold, Helvetica;
  //   font-weight: bold;
  //   color: #FFFFFF;
  //   line-height: 20.5px;
  // }
  // .download {
  //   margin-top: 12.5px;
  //   font-size: 13px;
  //   font-family: Helvetica;
  //   color: #989898;
  //   line-height: 15.5px;
  // }
  }
}
@media only screen and (min-width: 767px) {
.all {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .text-pc {
    display: flex;
    // width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    img {
      width: 518px;
      height: 630px;
    }
    .right {
      padding-left: 42px;
      .outer-box {
        width: 703px;
        overflow: hidden;
      }
      .suggest {
        height: 460px;
        width: 718px;
        overflow-y: auto;
        // white-space: wrap;
      }
      .p1 {
        // width: 528px;
        height: 64px;
        // padding-bottom: 21px;
        font-size: 40px;
        font-family: Helvetica-Bold, Helvetica;
        font-weight: bold;
        color: #000000;
        line-height: 48px;
      }
      .p2 {
        // width: 380px;
        // height: 34px;
        padding-top: 15px;
        // white-space:normal;
        font-size: 30px;
        font-family: Helvetica;
        color: #000000;
        line-height: 36px;
      }
      .p3 {
        // width: 718px;
        // height: 182px;
        padding-top: 13px;
        padding-bottom: 17px;
        // white-space:normal;
        font-size: 24px;
        font-family: Helvetica-Light, Helvetica;
        font-weight: 300;
        color: #000000;
        line-height: 34px;
      }
    }
  }
}
}


</style>